export interface ClientServerMessage {
    MessageType: ClientServerMessageType;
    FileContent: string;
    FileName: string;
}

export enum ClientServerMessageType {
    ReadFile = 1,
    WriteFile = 2,
}
